import { CanDeactivateFn } from '@angular/router';

import { IComponentCanDeactivate } from '../interfaces/component-can-deactivate';

export const pendingChangesGuard: CanDeactivateFn<IComponentCanDeactivate> = (component) => {
  return component ? component.canDeactivate() : true;
};
